// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6037e465","553":"db2825f7","977":"912715fe"}[chunkId] + ".chunk.js";
};